module.exports = __webpack_public_path__ + "static/media/Kayan-Healthcare-Logo.422de27a.svg";